import { h, Fragment } from "preact";
import { useEffect, useState } from "preact/hooks";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  FreeMode,
  Grid,
  Mousewheel,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import ProductCard from "./product-card.jsx";
import storefront from "../storefront";
import * as queries from "../storefront/queries";

const ProductCarousel = ({ products, swiperParams = [], cardStyle }) => {
  const [validProducts, setValidProducts] = useState([]);

  // Get Products By ID Sets based on Props
  const getProductsByIds = async () => {
    const response = await storefront.request({
      query: queries.products,
      variables: {
        ids: products.map(({ id }) => encodeId(id, "Product")),
      },
    });
    if (response?.data?.nodes) {
      const productData = {};

      response.data.nodes.forEach((product) => {
        if (!product) return;

        productData[product.id] = product;
      });

      const data = products
        .map(({ id, preselect_color }) => {
          const gid = `gid://shopify/Product/${id}`;

          if (!(gid in productData)) return null;

          return {
            product: productData[gid],
            preselect_color,
          };
        })
        .filter((item) => item !== null);

      setValidProducts(data);
    }
  };

  console.log("productData", validProducts);

  useEffect(() => {
    getProductsByIds();
  }, []);

  return (
    <Swiper
      {...swiperParams}
      modules={[FreeMode, Grid, Mousewheel, Scrollbar, Navigation]}
    >
      {validProducts.map(({ product, preselect_color }) => {
        return (
          <SwiperSlide className="product-carousel__slide">
            <ProductCard
              data={product}
              preselectColor={preselect_color}
              gallery={false}
              cardStyle={cardStyle}
            />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

export default ProductCarousel;
